<!--
  @Description: 政策-收藏
  @Author: wang.y 
  @Date: 2022-02-23 
-->
<template>
  <div>
    <div class="commonlist">
      <div class="item" v-for="(item, index) in list" :key="item.id">
        <div class="title over-p2" @click="$parent.goDetail(3, item.uid)"><span>政策</span>{{item.name}}</div>
        <div class="dec">
          <div class="lt">
            <div class="info-item"><i class="iconfont">&#xe632;</i>发文时间：{{item.publish_time | time_standard}}</div>
            <div class="info-item" v-if="item.address_id && item.address_id != '0'"><i class="iconfont">&#xe62c;</i>有效地区：{{item.address_id | addressDeal('3', $store.state.address)}}</div>
            <div class="info-item" v-if="item.publish_org"><i class="iconfont">&#xe633;</i>发文机关：{{item.publish_org}}</div>
          </div>
          <div class="collect_share">
            {{item.create_time}}
            <i class="iconfont collec-icon" @click="handleCancel('3', item.id, cancelCollectCb, index)" title="取消收藏">&#xe66f;</i>
          </div>
        </div>
      </div>
    </div>
    <Spin v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="more-btn" v-if="more && !loading">
      <div @click="handleMore('3')">加载更多</div>
    </div>
    <default-list v-if="!list.length && !loading">
      <template slot="p">
        <p>您目前没有收藏任何政策，不如去随便逛逛<br />看看有什么内容值得收藏起来，反复品读</p>
        <router-link :to="{ name: 'PolicyList' }">去政策列表看看</router-link>
      </template>
    </default-list>
  </div>
</template>
<script>
import DefaultList from './DefaultList'
import { collect_list } from 'js/collect_list'
export default {
  mixins: [collect_list],
  components: {
    DefaultList
  },
  created() {
    this.userFavorite('3')
  },
  mounted() { },
  data() {
    return {

    }
  },
  computed: {},
  methods: {

  }
}
</script>
<style lang="stylus" scoped></style>